import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Logo, LogoWhite } from '../../components/Logo/Logo';
import { useTranslation } from '../../language';
import RegisterForm from './RegisterForm';
import { useTheme } from '@mui/material';


export default function RegisterCard() {

  const { t } = useTranslation();
  const theme = useTheme();

    return (
    <>

      <Card elevation={0} variant="outlined"

              sx={{

                mx: '2',
                bgcolor: 'transparent',
                border: 'none',
                borderRadius: "12px",
                py: 2,

              }}>

                <CardContent sx={{display: 'grid', placeItems: 'center'}}>

                  <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                    {theme.palette.mode === 'dark' ? <LogoWhite /> : <Logo />}
                  </Box>

                  <Typography variant="h3" sx={{ mb: 1, textAlign: 'center' }}>
                    {t('login_headline')}
                  </Typography>

                  <Typography variant="subtitle1" sx={{ mb: 2, textAlign: 'center', fontWeight: 400 }}>
                    {t('reg_headline')}
                  </Typography>

                  <Box sx={{ width: '100%' }}>
                    <RegisterForm />
                  </Box>

                 </CardContent>
               </Card>

  </>
  )
}
